import { z } from "zod";
const dateBasisSchema = z.enum(["last_activity", "creation_date"]);
const DEFAULT_DATE_BASIS = "last_activity";
export {
  DEFAULT_DATE_BASIS,
  dateBasisSchema
};
//# sourceMappingURL=dateBasis.js.map
